module.exports = __webpack_public_path__ + "img/Zimmer_Hartmann.fb470d27.jpg";